import e from"styled-components";import{Text as t}from"../../Text/Text.js";var o=e(t).withConfig({componentId:"sc-g9ntzd-0"})(["user-select:none;text-align:center;padding:0.8rem 1rem;margin-bottom:0.8rem;"]);export{o as WeekDay};
